module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoUltLt.cbf774cd.otf";